import { connectMediaStore } from './withOwnReduxStore';
import { getAllowUploads, getAllowMultipleUploads } from '../selectors';
import { uploadFile, uploadFiles } from '../actions';
import { getAllUploads } from '../../redux/uploads/selectors';
export default connectMediaStore((state)=>({
        fileUploads: getAllUploads(state),
        allowUploads: getAllowUploads(state),
        allowMultipleUploads: getAllowMultipleUploads(state)
    }), {
    uploadFile,
    uploadFiles
});

//# sourceMappingURL=withFileUpload.js.map